__webpack_require__.p = "//img0.didiglobal.com/static/soda_static/gattaran-workshop-i18n/app/dist/";